import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
export default function Home() {
    return (
        <>
            <Hero />
            <About />
            <Services />
            <Stats />
            <Testimonials />
        </>
    );
};
